(() => {
  let customerChangedVariant = false;
  let filterTimer;
 
  const normalize = (value) =>
    String(value || "")
      .trim()
      .toLowerCase();
 
  function getProductSection(element) {
    return (
      element.closest("product-information") ||
      element.closest(".shopify-section") ||
      document
    );
  }
 
  function getSelectedVariantValue(productSection) {
    const checkedRadio = productSection.querySelector(
      'input[type="radio"]:checked'
    );
 
    if (checkedRadio) {
      return checkedRadio.value;
    }
 
    const selectedOption = productSection.querySelector(
      "select option:checked"
    );
 
    return selectedOption ? selectedOption.value : "";
  }
 
  function findMediaItem(image) {
    return (
      image.closest("slideshow-slide") ||
      image.closest("[data-media-id]") ||
      image.closest(".product-media-container") ||
      image.closest(".product__media-item") ||
      image.closest("li")
    );
  }
 
  function filterProductMedia(productSection, selectedValue) {
    selectedValue = normalize(selectedValue);
 
    if (!selectedValue) return;
 
    const gallery =
      productSection.querySelector("media-gallery") ||
      productSection.querySelector("[data-product-media-gallery]") ||
      productSection;
 
    const images = gallery.querySelectorAll("img[alt]");
 
    const processedItems = new Set();
    let firstMatchingItem = null;
 
    images.forEach((image) => {
      const mediaItem = findMediaItem(image);
 
      if (!mediaItem || processedItems.has(mediaItem)) return;
 
      processedItems.add(mediaItem);
 
      const imageAlt = normalize(image.getAttribute("alt"));
 
      /*
       * Keep images with no useful ALT text visible.
       * Otherwise show only images matching the selected variant.
       */
      const shouldShow =
        !imageAlt ||
        imageAlt === selectedValue ||
        imageAlt.includes(selectedValue);
 
      mediaItem.hidden = !shouldShow;
      mediaItem.style.setProperty(
        "display",
        shouldShow ? "" : "none",
        shouldShow ? "" : "important"
      );
 
      mediaItem.setAttribute(
        "aria-hidden",
        shouldShow ? "false" : "true"
      );
 
      if (shouldShow && !firstMatchingItem) {
        firstMatchingItem = mediaItem;
      }
    });
 
    /*
     * Filter thumbnails separately because Horizon can render them
     * outside the main slide structure.
     */
    const thumbnails = gallery.querySelectorAll(
      'button img[alt], [role="tab"] img[alt], .slideshow-controls__thumbnail img[alt]'
    );
 
    thumbnails.forEach((thumbnailImage) => {
      const thumbnailButton =
        thumbnailImage.closest("button") ||
        thumbnailImage.closest('[role="tab"]') ||
        thumbnailImage.parentElement;
 
      const thumbnailAlt = normalize(
        thumbnailImage.getAttribute("alt")
      );
 
      const shouldShow =
        !thumbnailAlt ||
        thumbnailAlt === selectedValue ||
        thumbnailAlt.includes(selectedValue);
 
      if (thumbnailButton) {
        thumbnailButton.hidden = !shouldShow;
        thumbnailButton.style.setProperty(
          "display",
          shouldShow ? "" : "none",
          shouldShow ? "" : "important"
        );
      }
    });
 
    /*
     * Activate the first matching slide.
     */
    if (firstMatchingItem) {
      const firstButton =
        firstMatchingItem.querySelector("button") ||
        firstMatchingItem.querySelector("a");
 
      const matchingThumbnail = Array.from(thumbnails).find(
        (thumbnailImage) =>
          normalize(thumbnailImage.getAttribute("alt")) ===
          selectedValue
      );
 
      const matchingThumbnailButton =
        matchingThumbnail?.closest("button") ||
        matchingThumbnail?.closest('[role="tab"]');
 
      if (matchingThumbnailButton) {
        matchingThumbnailButton.click();
      } else if (firstButton) {
        firstButton.click();
      }
 
      firstMatchingItem.scrollIntoView({
        behavior: "auto",
        block: "nearest",
        inline: "nearest",
      });
    }
  }
 
function runFilter(productSection) {

  // Deal Offer uses Shopify's native variant-image system.
  // Do NOT run the old ALT-based media filter here.
  const isDealOffer =
    window.location.pathname.includes('/products/deal-offer') ||
    productSection.querySelector(
      'variant-picker[data-product-handle="deal-offer"]'
    );

  if (isDealOffer) {
    return;
  }

  clearTimeout(filterTimer);

  filterTimer = setTimeout(() => {
    const selectedValue =
      getSelectedVariantValue(productSection);

    filterProductMedia(productSection, selectedValue);
  }, 100);
}
  /*
   * Native radio/select variant changes.
   */
  document.addEventListener(
    "change",
    (event) => {
      const variantInput = event.target.closest(
        'input[type="radio"], select'
      );
 
      if (!variantInput) return;
 
      const productSection = getProductSection(variantInput);
 
      customerChangedVariant = true;
 
      runFilter(productSection);
 
      /*
       * Horizon may rebuild the gallery after changing the variant.
       */
      setTimeout(() => runFilter(productSection), 300);
      setTimeout(() => runFilter(productSection), 700);
    },
    true
  );
 
  /*
   * Also detect swatch/button clicks because some Horizon configurations
   * update the selected input after the click event.
   */
  document.addEventListener(
    "click",
    (event) => {
      const variantControl = event.target.closest(
        'label[for], variant-picker button, .variant-option button'
      );
 
      if (!variantControl) return;
 
      const productSection = getProductSection(variantControl);
 
      customerChangedVariant = true;
 
      setTimeout(() => runFilter(productSection), 100);
      setTimeout(() => runFilter(productSection), 500);
    },
    true
  );
 
  /*
   * Reapply filtering whenever Horizon replaces gallery markup.
   */
  const observer = new MutationObserver((mutations) => {
    if (!customerChangedVariant) return;
 
    const relevantMutation = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some(
        (node) =>
          node.nodeType === 1 &&
          (
            node.matches?.(
              "media-gallery, slideshow-slide, [data-media-id]"
            ) ||
            node.querySelector?.(
              "media-gallery, slideshow-slide, [data-media-id]"
            )
          )
      )
    );
 
    if (!relevantMutation) return;
 
    document
      .querySelectorAll("product-information")
      .forEach((productSection) => {
        runFilter(productSection);
      });
  });
 
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();















document.addEventListener("DOMContentLoaded", () => {

  const title = document.querySelector("h1");
  if (!title) return;

  // Original title save karo
  const originalTitle = title.textContent.trim();

  function updateTitle() {

    const selected = document.querySelector(
      'variant-picker input[type="radio"]:checked'
    );

    if (!selected) return;

    const color = selected.value.trim();

    // "White Dial" ya "Black Dial" replace karega
    title.textContent = originalTitle.replace(
      /(White|Black|Blue|Green)/i,
      color
    );
  }

  updateTitle();

  document.addEventListener("change", (e) => {
    if (e.target.closest("variant-picker")) {
      setTimeout(updateTitle, 100);
    }
  });

});















// Deal Offer - Hide unavailable variant buttons
document.addEventListener('DOMContentLoaded', function () {

  function hideUnavailableDealOptions() {

    if (!window.location.pathname.includes('/products/deal-offer')) return;

    document.querySelectorAll(
      '.variant-option__button-label input[type="radio"][data-option-available="false"]'
    ).forEach(function(input) {

      const label = input.closest('.variant-option__button-label');

      if (label) {
        label.style.setProperty('display', 'none', 'important');
      }

    });

  }

  // Run immediately
  hideUnavailableDealOptions();

  // Horizon dynamically changes variant availability
  document.addEventListener('change', function () {
    setTimeout(hideUnavailableDealOptions, 100);
  });

  // Watch Shopify DOM updates
  const observer = new MutationObserver(function () {
    hideUnavailableDealOptions();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-option-available', 'aria-disabled']
  });

});

console.log('🔥 DEAL OFFER HIDE CODE LOADED 🔥');















// // =====================================================
// // DEAL OFFER - FAST BUNDLE
// // 1 ROLEX + 1 PATEK + FREE WAYFARER
// // =====================================================

// document.addEventListener('DOMContentLoaded', async function () {

//   if (!location.pathname.includes('/products/deal-offer')) return;

//   const FREE_GIFT_ID = 54558023647456;

//   const picker = document.querySelector(
//     'variant-picker[data-product-handle="deal-offer"]'
//   );

//   if (!picker) return;

//   let productData;
//   let selectedRolex = null;
//   let selectedPatek = null;
//   let busy = false;

//   try {
//     productData = await fetch('/products/deal-offer.js')
//       .then(r => r.json());
//   } catch (e) {
//     console.error('Deal Offer data error', e);
//     return;
//   }

//   // -------------------------
//   // STATUS BOX
//   // -------------------------

//   const box = document.createElement('div');
//   box.id = 'deal-bundle-status';

//   box.innerHTML = `
//     <div class="bundle-title">COMPLETE YOUR DEAL</div>
//     <div class="bundle-rolex">○ Select 1 Rolex Watch</div>
//     <div class="bundle-patek">○ Select 1 Patek Philippe Watch</div>
//     <div class="bundle-free">🎁 FREE Wayfarer Sunglasses Included</div>
//     <div class="bundle-total">Deal Total: <strong>Rs.6,666</strong></div>
//   `;

//   picker.insertAdjacentElement('afterend', box);

//   const style = document.createElement('style');

//   style.textContent = `
//     #deal-bundle-status{
//       margin:14px 0;
//       padding:14px;
//       border:1px solid #ddd;
//       border-radius:10px;
//       background:#fafafa;
//       font-size:14px;
//     }

//     .bundle-title{
//       font-weight:700;
//       margin-bottom:8px;
//     }

//     .bundle-rolex,
//     .bundle-patek{
//       margin:5px 0;
//     }

//     .bundle-free{
//       margin-top:9px;
//       font-weight:600;
//     }

//     .bundle-total{
//       margin-top:6px;
//     }

//     .deal-not-ready{
//       opacity:.45 !important;
//       cursor:not-allowed !important;
//     }
//   `;

//   document.head.appendChild(style);

//   // -------------------------
//   // CURRENT VARIANT
//   // -------------------------

//   function currentVariant() {

//     const collection = picker.querySelector(
//       'input[data-option-name="Collection"]:checked'
//     )?.value;

//     const dial = picker.querySelector(
//       'input[data-option-name="Dial Color"]:checked'
//     )?.value;

//     if (!collection || !dial) return null;

//     return productData.variants.find(v =>
//       v.option1 === collection &&
//       v.option2 === dial
//     );
//   }

//   // -------------------------
//   // SAVE SELECTION
//   // -------------------------

//   function rememberSelection() {

//     const variant = currentVariant();

//     if (!variant || !variant.available) return;

//     if (variant.option1 === 'Rolex') {
//       selectedRolex = variant;
//     }

//     if (variant.option1 === 'Patek Philippe') {
//       selectedPatek = variant;
//     }

//     updateUI();
//   }

//   function ready() {
//     return Boolean(selectedRolex && selectedPatek);
//   }

//   // -------------------------
//   // UI
//   // -------------------------

//   function updateUI() {

//     box.querySelector('.bundle-rolex').innerHTML =
//       selectedRolex
//         ? `✓ Rolex: <strong>${selectedRolex.option2}</strong>`
//         : '○ Select 1 Rolex Watch';

//     box.querySelector('.bundle-patek').innerHTML =
//       selectedPatek
//         ? `✓ Patek Philippe: <strong>${selectedPatek.option2}</strong>`
//         : '○ Select 1 Patek Philippe Watch';

//     const canBuy = ready();

//     document
//       .querySelectorAll(
//         'form[action*="/cart/add"] button[type="submit"], .shopify-payment-button__button'
//       )
//       .forEach(btn => {

//         btn.disabled = !canBuy;

//         btn.classList.toggle(
//           'deal-not-ready',
//           !canBuy
//         );
//       });
//   }

//   // Only ONE delayed check per variant change
//   let selectionTimer;

//   picker.addEventListener('change', function () {

//     clearTimeout(selectionTimer);

//     selectionTimer = setTimeout(
//       rememberSelection,
//       120
//     );
//   });

//   // -------------------------
//   // ADD ALL 3 ITEMS
//   // -------------------------

//   async function addBundle(quantity) {

//     const response = await fetch('/cart/add.js', {
//       method: 'POST',

//       headers: {
//         'Content-Type': 'application/json',
//         'Accept': 'application/json'
//       },

//       body: JSON.stringify({
//         items: [
//           {
//             id: selectedRolex.id,
//             quantity
//           },
//           {
//             id: selectedPatek.id,
//             quantity
//           },
//           {
//             id: FREE_GIFT_ID,
//             quantity,
//             properties: {
//               '_Free Gift With': 'Deal Offer'
//             }
//           }
//         ]
//       })
//     });

//     if (!response.ok) {
//       throw new Error('Bundle could not be added');
//     }
//   }

//   // -------------------------
//   // ADD TO CART
//   // -------------------------

//   document.addEventListener(
//     'submit',
//     async function (event) {

//       const form = event.target;

//       if (!form.matches('form[action*="/cart/add"]')) {
//         return;
//       }

//       if (!ready()) {
//         event.preventDefault();
//         event.stopImmediatePropagation();

//         box.scrollIntoView({
//           behavior: 'smooth',
//           block: 'center'
//         });

//         return;
//       }

//       event.preventDefault();
//       event.stopImmediatePropagation();

//       if (busy) return;

//       busy = true;

//       const qty = Number(
//         form.querySelector('[name="quantity"]')?.value || 1
//       );

//       try {

//         await addBundle(qty);

//         location.href = '/cart';

//       } catch (e) {

//         console.error(e);
//         busy = false;
//       }

//     },
//     true
//   );

//   // -------------------------
//   // BUY IT NOW
//   // -------------------------

//   document.addEventListener(
//     'click',
//     async function (event) {

//       const btn = event.target.closest(
//         '.shopify-payment-button__button'
//       );

//       if (!btn) return;

//       event.preventDefault();
//       event.stopImmediatePropagation();

//       if (!ready()) {

//         box.scrollIntoView({
//           behavior: 'smooth',
//           block: 'center'
//         });

//         return;
//       }

//       if (busy) return;

//       busy = true;

//       const qty = Number(
//         document.querySelector(
//           'form[action*="/cart/add"] [name="quantity"]'
//         )?.value || 1
//       );

//       try {

//         await addBundle(qty);

//         location.href = '/checkout';

//       } catch (e) {

//         console.error(e);
//         busy = false;
//       }

//     },
//     true
//   );

//   // Initial watch selection
//   setTimeout(function () {
//     rememberSelection();
//   }, 300);

// });





























// =====================================================
// DEAL OFFER - FAST BUNDLE
// 1 ROLEX + 1 PATEK + FREE WAYFARER
// =====================================================

document.addEventListener('DOMContentLoaded', async function () {

  if (!location.pathname.includes('/products/deal-offer')) return;

  const FREE_GIFT_ID = 54558023647456;

  const picker = document.querySelector(
    'variant-picker[data-product-handle="deal-offer"]'
  );

  if (!picker) {
    console.warn('Deal Offer variant picker not found');
    return;
  }

  let productData;
  let selectedRolex = null;
  let selectedPatek = null;
  let busy = false;

  try {
    const response = await fetch('/products/deal-offer.js');

    if (!response.ok) {
      throw new Error('Could not load Deal Offer product');
    }

    productData = await response.json();

  } catch (e) {
    console.error('Deal Offer data error:', e);
    return;
  }


  // =====================================================
  // STATUS BOX
  // =====================================================

  const box = document.createElement('div');
  box.id = 'deal-bundle-status';

  box.innerHTML = `
    <div class="bundle-title">COMPLETE YOUR DEAL</div>

    <div class="bundle-rolex">
      ○ Select 1 Rolex Watch
    </div>

    <div class="bundle-patek">
      ○ Select 1 Patek Philippe Watch
    </div>

    <div class="bundle-free">
      🎁 FREE Wayfarer Sunglasses Included
    </div>

    <div class="bundle-total">
      Deal Total: <strong>Rs.6,666</strong>
    </div>
  `;

  picker.insertAdjacentElement('afterend', box);


  // =====================================================
  // CSS
  // =====================================================

  const style = document.createElement('style');

  style.textContent = `

    #deal-bundle-status{
      margin:14px 0;
      padding:14px;
      border:1px solid #ddd;
      border-radius:10px;
      background:#fafafa;
      font-size:14px;
    }

    .bundle-title{
      font-weight:700;
      margin-bottom:8px;
    }

    .bundle-rolex,
    .bundle-patek{
      margin:5px 0;
    }

    .bundle-free{
      margin-top:9px;
      font-weight:600;
    }

    .bundle-total{
      margin-top:6px;
    }

    .deal-not-ready{
      opacity:.45 !important;
      cursor:not-allowed !important;
      pointer-events:auto !important;
    }

  `;

  document.head.appendChild(style);


  // =====================================================
  // GET CURRENT VARIANT
  // =====================================================

  function currentVariant() {

    const collection = picker.querySelector(
      'input[data-option-name="Collection"]:checked'
    )?.value;

    const dial = picker.querySelector(
      'input[data-option-name="Dial Color"]:checked'
    )?.value;

    if (!collection || !dial) {
      return null;
    }

    return productData.variants.find(function (variant) {

      return (
        variant.option1 === collection &&
        variant.option2 === dial
      );

    }) || null;
  }


  // =====================================================
  // SAVE WATCH SELECTION
  // =====================================================

  function rememberSelection() {

    const variant = currentVariant();

    if (!variant) return;

    if (!variant.available) return;


    if (variant.option1 === 'Rolex') {

      selectedRolex = variant;

      console.log(
        'Rolex selected:',
        selectedRolex.title,
        selectedRolex.id
      );
    }


    if (variant.option1 === 'Patek Philippe') {

      selectedPatek = variant;

      console.log(
        'Patek selected:',
        selectedPatek.title,
        selectedPatek.id
      );
    }

    updateUI();
  }


  function ready() {

    return Boolean(
      selectedRolex &&
      selectedPatek
    );
  }


  // =====================================================
  // UPDATE UI
  // =====================================================

  function updateUI() {

    const rolexText = box.querySelector('.bundle-rolex');
    const patekText = box.querySelector('.bundle-patek');


    rolexText.innerHTML = selectedRolex
      ? `✓ Rolex: <strong>${selectedRolex.option2}</strong>`
      : '○ Select 1 Rolex Watch';


    patekText.innerHTML = selectedPatek
      ? `✓ Patek Philippe: <strong>${selectedPatek.option2}</strong>`
      : '○ Select 1 Patek Philippe Watch';


    const canBuy = ready();


    document
      .querySelectorAll(
        'form[action*="/cart/add"] button[type="submit"]'
      )
      .forEach(function (btn) {

        btn.disabled = !canBuy;

        btn.classList.toggle(
          'deal-not-ready',
          !canBuy
        );
      });


    document
      .querySelectorAll(
        '.shopify-payment-button__button'
      )
      .forEach(function (btn) {

        btn.classList.toggle(
          'deal-not-ready',
          !canBuy
        );
      });
  }


  // =====================================================
  // WATCH VARIANT CHANGES
  // =====================================================

  let selectionTimer = null;

  picker.addEventListener('change', function () {

    clearTimeout(selectionTimer);

    selectionTimer = setTimeout(function () {

      rememberSelection();

    }, 150);

  });


  // =====================================================
  // ADD COMPLETE BUNDLE TO CART
  // =====================================================

  async function addBundle(quantity) {

    if (!selectedRolex || !selectedPatek) {

      throw new Error(
        'Rolex and Patek must both be selected'
      );
    }


    const items = [

      {
        id: Number(selectedRolex.id),
        quantity: quantity,

        properties: {
          '_Deal Product': 'Rolex'
        }
      },

      {
        id: Number(selectedPatek.id),
        quantity: quantity,

        properties: {
          '_Deal Product': 'Patek Philippe'
        }
      },

      {
        id: Number(FREE_GIFT_ID),
        quantity: quantity,

        properties: {
          '_Free Gift With': 'Deal Offer',
          '_Free Gift': 'Wayfarer Sunglasses'
        }
      }

    ];


    console.log('Adding bundle:', items);


    const response = await fetch(
      window.Shopify.routes.root + 'cart/add.js',
      {

        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },

        body: JSON.stringify({
          items: items
        })

      }
    );


    const result = await response.json();


    if (!response.ok) {

      console.error(
        'Shopify cart error:',
        result
      );

      throw new Error(
        result.description ||
        result.message ||
        'Bundle could not be added'
      );
    }


    console.log(
      'Bundle successfully added:',
      result
    );

    return result;
  }


  // =====================================================
  // GET QUANTITY
  // =====================================================

  function getQuantity() {

    const quantityInput = document.querySelector(
      'form[action*="/cart/add"] [name="quantity"]'
    );

    const quantity = Number(
      quantityInput?.value || 1
    );

    return quantity > 0
      ? quantity
      : 1;
  }


  // =====================================================
  // SHOW SELECTION BOX
  // =====================================================

  function showSelectionBox() {

    box.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

  }


  // =====================================================
  // ADD TO CART
  // =====================================================

  document.addEventListener(
    'submit',
    async function (event) {

      const form = event.target;


      if (
        !form.matches(
          'form[action*="/cart/add"]'
        )
      ) {
        return;
      }


      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();


      if (!ready()) {

        showSelectionBox();

        return;
      }


      if (busy) return;

      busy = true;


      const qty = getQuantity();


      try {

        await addBundle(qty);

        window.location.assign(
          window.Shopify.routes.root + 'cart'
        );

      } catch (error) {

        console.error(
          'Add to cart failed:',
          error
        );

        busy = false;
      }

    },

    true
  );


  // =====================================================
  // BUY IT NOW
  // =====================================================

  document.addEventListener(
    'click',
    async function (event) {

      const button = event.target.closest(
        '.shopify-payment-button__button'
      );


      if (!button) return;


      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();


      if (!ready()) {

        showSelectionBox();

        return;
      }


      if (busy) return;

      busy = true;


      const originalText =
        button.textContent;


      button.disabled = true;

      button.textContent =
        'Preparing checkout...';


      try {

        const qty = getQuantity();


        await addBundle(qty);


        // Small delay so Shopify cart session
        // definitely updates before checkout
        await new Promise(function (resolve) {

          setTimeout(resolve, 400);

        });


        window.location.href =
          window.Shopify.routes.root + 'checkout';


      } catch (error) {

        console.error(
          'Buy It Now failed:',
          error
        );


        busy = false;

        button.disabled = false;

        button.textContent =
          originalText;
      }

    },

    true
  );


  // =====================================================
  // INITIAL SELECTION
  // =====================================================

  setTimeout(function () {

    rememberSelection();

    updateUI();

  }, 400);

});